import { CustomerDetailElementDataType } from '@/components/sections/builder/elements/body/customer/customer_detail/type';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import { ElementProps } from '@/components/sections/builder/types';
import { useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export default function ElementSettingCustomerDetail({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setElementData: state.setElementData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const content = element.data as CustomerDetailElementDataType;

  return (
    <div>
      <div className='mb-1 mt-4 font-bold md:mt-4'>Section Padding</div>
      <InputSlider
        label='Top padding'
        value={content.topPadding}
        onChange={(val) =>
          builder.setElementData(element.id, {
            topPadding: val,
          })
        }
      />
      <InputSlider
        label='Bottom padding'
        value={content.bottomPadding}
        onChange={(val) =>
          builder.setElementData(element.id, {
            bottomPadding: val,
          })
        }
      />
      <div className='mb-2 mt-4 font-bold'>Color scheme</div>
      <SchemeSetting
        value={content.colorScheme}
        onChange={(theme) => {
          builder.setElementData(element.id, {
            colorScheme: theme,
          });
        }}
      />
    </div>
  );
}
